import {Component, OnInit} from '@angular/core';
import {NavigationService, UserService} from '@core/services';
import {lastValueFrom} from "rxjs";

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: false
})
export class NotFoundComponent implements OnInit {

  constructor(
    private _userService: UserService,
    private _navigationService: NavigationService) {
  }

  ngOnInit(): void {
  }

  async backToMain(): Promise<void> {
    const isLoggedIn = await lastValueFrom(this._userService.isLoggedIn);
    if (!isLoggedIn) {
      return;
    }
    const userRoleId = this._userService.user?.role_id;
    this._navigationService.navigateToMain(userRoleId);
  }


}
